export class WebText {
  es: string;
  en: string;
    
  constructor(es: string, 
              en: string) {
    this.es = es;
    this.en = en;
  }
}